import { createSlice } from '@reduxjs/toolkit';

export const applyOpportunitySlice = createSlice({
  name: 'applyopportunities',
  initialState: {
    data: [],
  },
  reducers: {
    setOpportunities: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setOpportunities } = applyOpportunitySlice.actions;

export const selectApplyOpportunities = (state) => state.applyopportunities.data;

export default applyOpportunitySlice.reducer;
